module.exports = __webpack_public_path__ + "media/images/www/company/sofa-double-dcee32f068f8014d8cb4dd44d20ba98b.svg";